export default "__VITE_ASSET__e96270b1__"